/**
 * Real DevSkin Browser SDK (Flux / devskin-monitoring) install snippet.
 * Mirrors backend src/services/vercelService.js generateFluxScript so the blog UI
 * shows the SAME script the landing pages inject. Flux is CLIENT-SIDE: this snippet
 * goes in the blog's <head> and then sends pageviews/origins/sessions to
 * devskin-monitoring automatically. There is no "activate via API" step.
 */
export function generateFluxSnippet(apiKey: string, appId: string): string {
  const key = apiKey || 'SUA_API_KEY';
  const app = appId || 'SEU_APP_ID';
  return `<!-- Flux Analytics - Session Recording & Heatmaps -->
<script>
  (function(w,d,c,a,b){
    if(/bot|crawler|spider|lighthouse|pagespeed|gtmetrix|headless/i.test(navigator.userAgent))return;
    w.DevSkin=w.DevSkin||function(){(w.DevSkin.q=w.DevSkin.q||[]).push(Array.prototype.slice.call(arguments))};
    w.DevSkin.l=Date.now();
    w.DevSkin('init',c);
    a=d.getElementsByTagName('head')[0];
    b=d.createElement('script');
    b.async=1;
    b.src='https://cdn.jsdelivr.net/npm/@devskin/browser-sdk@latest/dist/devskin.umd.min.js';
    a.appendChild(b);
  })(window,document,{
    apiKey: '${key}',
    appId: '${app}',
    apiUrl: 'https://api-monitoring.devskin.com',
    sessionRecording: { enabled: true, maskAllInputs: true, sampling: 1 },
    heatmapOptions: { enabled: true, trackClicks: true, trackScroll: true, trackMouseMovement: true, mouseMoveSampling: 0.1 },
    captureWebVitals: true,
    captureNetworkRequests: true,
    captureErrors: true,
    privacy: { respectDoNotTrack: true, cookieConsent: false },
    environment: 'production',
    debug: false
  });
</script>`;
}

export const FLUX_FEATURES = [
  { key: 'sessions', label: 'Gravação de sessões' },
  { key: 'heatmaps', label: 'Heatmaps de clique' },
  { key: 'vitals', label: 'Core Web Vitals' },
  { key: 'origins', label: 'Acessos e origens de tráfego' }
];
